import { render, staticRenderFns } from "./GroupTemplateEditSidebar.vue?vue&type=template&id=b60bc6c4&"
import script from "./GroupTemplateEditSidebar.vue?vue&type=script&lang=js&"
export * from "./GroupTemplateEditSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports